import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import TutorSearchPage from './pages/TutorSearchPage';
import SyllabusPage from './pages/SyllabusPage';
import ResourceListPage from './pages/ResourceListPage';
import ShopPage from './pages/ShopPage';
import ProductDetails from './pages/ProductDetails';
import CartPage from './pages/CartPage';
import BlogPage from './pages/BlogPage';
import SingleBlog from './pages/SingleBlog';
import HelpSupport from './pages/HelpSupport';
import ContactPage from './pages/ContactPage';
import PrivateClassesPage from './pages/PrivateClassesPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import TeacherLoginPage from './pages/TeacherLoginPage';
import TeacherAdminPage from './pages/TeacherAdminPage';
import StudentProfilePage from './pages/StudentProfilePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-darkBg text-white selection:bg-accentBlue selection:text-black">
        {/* Navigation Bar - All pages wala pennanna */}
        <ScrollToTop />
        <Navbar />
        
        {/* Main Content Area */}
        <main className="relative pt-4">
          <Routes>
            <Route path="/" element={<HomePage />} />
            
            {/* Find a Tutor Page Route */}
            <Route path="/tutors" element={<TutorSearchPage />} />

            {/* Private Classes Page Route */}
            <Route path="/private" element={<PrivateClassesPage />} />

            {/* Dynamic Syllabus Route (Local, Cambridge, Edexcel) */}
            <Route path="/syllabus/:type" element={<SyllabusPage />} />
            
            {/* Resource Listing Route (Specific to category like Past Papers/Videos) */}
            <Route path="/syllabus/:type/:category" element={<ResourceListPage />} />

            {/* Shop Page Route */}
            <Route path="/shop" element={<ShopPage />} />

            {/* Product Details Route */}
            <Route path="/shop/:id" element={<ProductDetails />} />

            {/* Cart & Checkout Route */}
            <Route path="/cart" element={<CartPage />} />

            {/* Blog Routes */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<SingleBlog />} />

            {/* Help & Support Route */}
            <Route path="/support" element={<HelpSupport />} />

            {/* Contact Page Route */}
            <Route path="/contact" element={<ContactPage />} />

            {/* Admin Routes */}
            <Route path="/admin/*" element={<AdminPage />} />
            <Route path="/teachers/admin/*" element={<TeacherAdminPage />} />
            <Route path="/student-profile" element={<StudentProfilePage />} />
            
            {/* Auth Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/teacher-login" element={<TeacherLoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

            {/* Static paths pointing to the dynamic component for easier navigation */}
            <Route path="/local" element={<SyllabusPage />} />
            <Route path="/cambridge" element={<SyllabusPage />} />
            <Route path="/edexcel" element={<SyllabusPage />} />
            
          </Routes>
        </main>

        <Footer />
        <ScrollToTopButton />

        {/* Background Glow Effects for Premium Look */}
        <div className="fixed top-0 left-1/2 -translate-x-1/2 w-full h-full -z-10 pointer-events-none">
          <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-accentBlue/10 blur-[120px] rounded-full"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-500/10 blur-[120px] rounded-full"></div>
        </div>
      </div>
    </Router>
  );
}

export default App;